import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { addTranslationForLanguage } from "react-localize-redux";
import { LocaleProvider } from "antd";
import deDE from "antd/lib/locale-provider/de_DE";
import "moment/locale/de";
// import admin from "firebase-admin";
// import functions from "firebase-functions";

import "./index.css";
import App from "./app.js";
import registerServiceWorker from "./register-service-worker.js";
import store from "./store.js";
import i18n from "./i18n.js";

Object.keys(i18n).forEach((json) => {
	store.dispatch(addTranslationForLanguage(i18n[json], json));
});

ReactDOM.render(
	<Provider store={store}>
		<LocaleProvider locale={deDE}>
			<App />
		</LocaleProvider>
	</Provider>,
	document.getElementById("root")
);

registerServiceWorker();

// if (window.location.hostname !== "localhost") {
// 	admin.initializeApp(functions.config().firebase);

// 	const db = admin.firestore();

// 	const docRef = db.collection("users").doc("alovelace");

// 	docRef.set({
// 		first: "Ada",
// 		last: "Lovelace",
// 		born: 1815
// 	});
// }



// WEBPACK FOOTER //
// ./src/index.js